export default __webpack_public_path__ + "static/media/Dr-VaraveenaMadhuri.1c1d8d47.jpg";